
import { useContext, useEffect, useRef, useState } from 'react';
import FormButton from '../dashboardComponents/FormButton';
import FormInfoCard from '../dashboardComponents/FormInfoCard';
import { AppContext } from '../../../contextApi/ContextApi';
import { DashboardContext } from '../../../contextApi/DashboardContext';

export default function SetBusinessInfoForm({website}) {
  const {setToastMessage, messagesOptions} = useContext(AppContext);
  const {handleChangeBusinessInfo} = useContext(DashboardContext);
  const [editFlag, setEditFlag] = useState(false);
  const [saveFlag, setSaveFlag] = useState(false);
  const [websiteName, setWebsiteName] = useState(website?.settings?.website_name);
  const [websiteEmail, setWebsiteEmail] = useState(website?.settings?.email);
  const [websitePhone, setWebsitePhone] = useState(website?.settings?.phone);
  const [websiteAddress, setWebsiteAddress] = useState(website?.settings?.address);
  const firstRender = useRef(true);
  
  // Updating the business info at firestore
  useEffect(()=>{
    if(!editFlag){
      if(firstRender.current){
        firstRender.current = false;
        return;
      }
      const newData = {
        name:websiteName,
        email:websiteEmail,
        phone:websitePhone,
        address:websiteAddress,
      }
      const func = async()=>{
        await handleChangeBusinessInfo(website, newData, setSaveFlag, setEditFlag, setToastMessage, messagesOptions);
      }
      func();
    }
  },[editFlag])

  return (
    <div>
        <FormInfoCard editFlag={editFlag} setInfo={setWebsiteName} label={"שם האתר:"} val={websiteName}/>
        <FormInfoCard editFlag={editFlag} setInfo={setWebsiteEmail} label={"אימייל:"} val={websiteEmail}/>
        <FormInfoCard editFlag={editFlag} setInfo={setWebsitePhone} label={"טלפון:"} val={websitePhone}/>
        <FormInfoCard editFlag={editFlag} setInfo={setWebsiteAddress} label={"כתובת:"} val={(websiteAddress === null || websiteAddress === "") ? "עדיין לא הוגדרה כתובת לעסק" : websiteAddress}/>
        <FormButton disabled={saveFlag} website={website} type={"button"} text={editFlag ? "שמור" : "ערוך"} action={()=>{setEditFlag(!editFlag)}}/>
    </div>
  )
}
